import { MealImageStatus, type StoredMeal } from '@/types/mealPlan'

// A meal doc is "frozen" — safe to cache permanently — only once `imageStatus === 'ready'`. The image
// triggers are the sole post-creation mutation, so a ready doc never changes again. `failed` is
// deliberately NOT frozen: the generation trigger retries, so it can still flip to ready.
export function isFrozen(meal: StoredMeal): boolean {
  return meal.imageStatus === MealImageStatus.Ready
}
